import React, { useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Slider from "react-slick";
import VideoModal from "../Video/Index"
const ProductLoop = ({ data, showPerPage, productType, stepID, productCat }) => {
    const [videoModal, setVideoModal] = React.useState(false)
    const [videoModalFull, setVideoModalFull] = React.useState(false)
    const [videoUrl, setVideoUrl] = React.useState('')
    const [prductDetails, setPrductDetails] = React.useState(false)
    const [selectedProducts, setSelectedProducts] = React.useState([])
    const [nav2, setnav2] = React.useState(null)
    const [nav1, setnav1] = React.useState(null)
    const [videoUrlFull, setvideoUrlFull] = React.useState('')
    const slider1 = useRef(null);
    const slider2 = useRef(null);
    let navigate = useNavigate();

    const goToDetails = (item) => {
        setSelectedProducts([item])
        toggleprductDetails()
        // if (productType === 'card') {

        //     navigate('/package-card-details/' + id)
        // } else {
        //     navigate('/package-accessories-details/' + id)
        // }

    }
    const toggle = () => {
        setVideoModal(!videoModal)
    }
    const toggleprductDetails = () => {
        setPrductDetails(!prductDetails)
    }
    const openModal = (url) => {
        setVideoUrl(url)
        setVideoModal(true)
    }
    const openModalFull = (url) => {
        setvideoUrlFull(url)
        setVideoModalFull(true)
    }
    const toggleVideo = () => {
        setvideoUrlFull('')
        setVideoModalFull(false)
    }
    const addToBasket = (items) => {
        let data = localStorage.getItem('porinoyMyPackage')
        if (data !== null) {
            let moddata = JSON.parse(data)
            moddata.step.forEach((item) => {
                if (item.id === stepID) {
                    item.selected = items
                }
            })
            localStorage.setItem('porinoyMyPackage', JSON.stringify(moddata))
            toggleprductDetails()
            toast.success('Item added to your package',{containerId:"packagecontainer"})
            window.location = '/my-package'
        }
    }
    let ifProduct = false;
    let galimgcount = 0;
    if (selectedProducts.length) {
        ifProduct = true
        galimgcount = selectedProducts[0].gallery[0].images.length
    }
    let bigimg = "";
    let ifcolorVar = false;
    if (ifProduct) {

        if (!ifcolorVar) {
            let selectedImages = selectedProducts[0].gallery[0].images;
            selectedImages.forEach((item) => {
                if (item.checked) {
                    bigimg = item.url
                }
            })
        }
    }
    // let ifrelatedprod = false;
    // if (this.state.relatedProducts.length) {
    //   ifrelatedprod = true
    // }

    return (
        <>
            <ToastContainer containerId={'packagecontainer'}
            
                />
            <div className="row">
                {data.map((item, index) => {
                    if (showPerPage >= (index + 1)) {
                        return <div key={index} className="col-12 col-lg-4 col-xl-4 col-md-6 mb-3">
                            <div className="cursor-pointer" >
                                <div className="mb-2 overflow-hidden position-relative">
                                    {item.videoUrl !== "" && <>  <span
                                        onClick={() => openModal(item.videoUrl)}
                                        style={{
                                            zIndex: "99",
                                            right: "10px",
                                            bottom: "10px",
                                            background: 'rgba(255, 255,255,.5)',
                                            color: '#000',
                                            lineHeight: "40px",
                                            width: "40px",
                                            height: "40px",
                                            textAlign: "center",
                                            borderRadius: "50%"

                                        }}
                                        className="videolink position-absolute"><i class="fa-solid fa-play"></i></span></>}
                                    <img alt="" onClick={(e) => goToDetails(item)} width="100%" className="opacity" src="../images/thumb-container.png" />
                                    <img alt={item.thumbAlt} onClick={(e) => goToDetails(item)} width="100%" className="position-absolute start-0 top-0" src={"../" + item.thumb} />
                                    {item.outOfstock &&
                                        <span className="outofstock">Out Of Stock</span>
                                    }
                                </div>
                                <div onClick={(e) => goToDetails(item)}>{item.name}</div>
                                <div onClick={(e) => goToDetails(item)}><i class="fa-solid fa-indian-rupee-sign"></i> {item.price}</div>
                            </div>
                        </div>
                    }
                })}

            </div>
            <Modal centered size="lg" isOpen={videoModal} toggle={toggle}>
                <ModalBody>
                    <span onClick={toggle} className="closeModal"><i class="fa-solid fa-circle-xmark"></i></span>
                    <VideoModal videoUrl={videoUrl} />
                </ModalBody>

            </Modal>
            {selectedProducts.length > 0 &&
                <Modal fullscreen={true} className="modal-fullscreen" centered isOpen={prductDetails} >
                    <div className="modal-header border-0 p-0 py-2 d-block ">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-auto">
                                <span style={{ position: "static" }} onClick={toggleprductDetails} className="closeModal">
                                    <i class="fa-solid fa-circle-xmark"></i>
                                </span>
                            </div>
                        </div>


                    </div>
                    <ModalBody className="pt-0">
                        <div className="row">
                            <div className="col-12 col-lg-6 col-xl-6 col-md-12">
                                <div className="border">
                                    <div className="row">
                                        <div className="col-12">
                                            <div style={{ padding: ".25rem" }} className="text-center position-relative">
                                                <Slider
                                                    asNavFor={nav2}
                                                    ref={(slider) => {
                                                        setnav1(slider);
                                                        slider1.current = slider;
                                                    }}
                                                    arrows={false}
                                                    infinite={galimgcount > 2 ? true : false}

                                                >
                                                    {ifProduct && selectedProducts[0].gallery[0].images.map((images, imgIndex) => {
                                                        return <div key={imgIndex} className=" " >
                                                            <div >
                                                                <div className="position-relative">
                                                                    <img alt="" width="100%" className="opacity d-block " src="../images/thumb-container.png" />

                                                                    <img alt={images.alt} width="100%" className="position-absolute start-0 top-0" src={"../" + images.url} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })}
                                                </Slider>
                                                {selectedProducts.length > 0 && selectedProducts[0].videoUrl !== "" && <> <span
                                                    onClick={() => openModalFull(selectedProducts[0].videoUrl)}
                                                    style={{
                                                        zIndex: "1",
                                                        right: "15px",
                                                        bottom: "15px",
                                                        background: 'rgba(255, 255,255,.5)',
                                                        color: '#000',
                                                        lineHeight: "40px",
                                                        width: "40px",
                                                        height: "40px",
                                                        textAlign: "center",
                                                        borderRadius: "50%",
                                                        cursor: 'pointer'

                                                    }}
                                                    className="videolink position-absolute">
                                                    <i class="fa-solid fa-play"></i>
                                                </span>
                                                </>}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            {ifProduct && <div className={galimgcount > 2 ? 'border border-top-0 multi' : 'border border-top-0 single'} >

                                                {selectedProducts.map((item, ind) => {
                                                    return <div key={ind}>
                                                        <div className="pdetailthumb" style={{ paddingBottom: ".25rem" }}>
                                                            <Slider
                                                                asNavFor={nav1}
                                                                ref={(slider) => {
                                                                    setnav2(slider);
                                                                    slider2.current = slider;
                                                                }}
                                                                slidesToShow={galimgcount > 2 ? 3 : galimgcount}
                                                                swipeToSlide={true}
                                                                focusOnSelect={true}
                                                                infinite={galimgcount > 2 ? true : false}
                                                            >
                                                                {item.gallery[0].images.map((images, imgIndex) => {
                                                                    return <div key={imgIndex} className="position-relative float-left cursor-pointer  detailThumb " >
                                                                        <div style={{ padding: "0px .25rem" }}>
                                                                            <div style={{ maxWidth: "225px" }} className="position-relative">
                                                                                <img alt="" width="100%" className="opacity d-block " src="../images/thumb-container.png" />

                                                                                <div className="seletedImgOverlay"></div>

                                                                                <img alt={images.alt} className="position-absolute start-0 top-0" src={"../" + images.url} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                })}
                                                            </Slider>
                                                        </div>


                                                    </div>

                                                })}
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 col-xl-6 col-md-12">

                                {ifProduct && <div>
                                    {selectedProducts.map((item, ind) => {
                                        // let ifcolor = false;
                                        let ifpaper = false;
                                        let ifwidth = false;
                                        let ifheight = false;
                                        let ifweight = false;
                                        if (item.width !== "") {
                                            ifwidth = true
                                        }
                                        if (item.height !== "") {
                                            ifheight = true
                                        }
                                        if (item.weight !== "") {
                                            ifweight = true
                                        }
                                        // if (item.color.length) {
                                        //   ifcolor = true
                                        // }
                                        if (item.paper !== "") {
                                            ifpaper = true
                                        }
                                        let ifcategory = false;
                                        if (item.category.length) {
                                            ifcategory = true
                                        }
                                        return <div key={ind}>
                                            <div style={{ fontSize: "1.6rem", fontWeight: "600" }} className="h1">{item.name}</div>
                                            <div className="h3"><i class="fa-solid fa-indian-rupee-sign"></i> {item.price}</div>

                                            <div className="mb-2">{item.description}</div>




                                            <div className="mb-2">
                                                <button
                                                    onClick={() => addToBasket(selectedProducts)}
                                                    // onClick={() => this.orderProduct()}
                                                    className="btn btn-danger btn-large">Add to Package</button>
                                            </div>
                                            <div className="bg-adiinfo p-2 rounded mb-2">
                                                <div className="row">
                                                    <div className="col-12 mb-2">
                                                        <div className="row">
                                                            <div className="col-12"><div className="h5">Additional Information</div></div>
                                                            {ifweight && <div className="col-4">
                                                                <div className="h6">Weight</div>
                                                                <div>{item.weight} Grams</div>
                                                            </div>}
                                                            {ifwidth && <div className="col-4">
                                                                <div className="h6">Width</div>
                                                                <div>{item.width} CMS</div>
                                                            </div>}
                                                            {ifheight && <div className="col-4">
                                                                <div className="h6">Height</div>
                                                                <div>{item.height} CMS</div>
                                                            </div>}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                    })}

                                </div>}
                            </div>
                        </div>
                    </ModalBody>

                </Modal>

            }
            <Modal centered size="lg" isOpen={videoModalFull} toggle={toggleVideo}>
                <ModalBody>
                    <span onClick={toggleVideo} className="closeModal"><i class="fa-solid fa-circle-xmark"></i></span>
                    <VideoModal videoUrl={videoUrlFull} />
                </ModalBody>

            </Modal>
        </>
    )
}
export default ProductLoop;